import { Moment } from 'moment';
import { WarningFill } from 'ui/icons/status/WarningFill';
import { InputText } from 'ui/inputs/inputText/InputText';
import { colors } from 'ui/theme/colors';

import {
  ErrorText,
  InputBar,
  RelativeDateMenu,
  RelativeDateValue,
  RelativeDateFragment,
  RelativeDateColumn,
} from './SingleDatePicker.styles';

export type RelativeDateValuesType = Array<{ [key: string]: { value: string; example?: string } }>;

export const RelativeDateValues: RelativeDateValuesType = [
  {
    Now: { value: 'now' },
    Years: { value: 'y' },
    Months: { value: 'M' },
    Weeks: { value: 'w' },
    Days: { value: 'd' },
  },
  {
    Hours: { value: 'h' },
    Minutes: { value: 'm' },
    Seconds: { value: 's' },
    Add: { value: '+' },
    Subtract: { value: '-' },
  },
  {
    Handlebars: { value: '{{ }}', example: 'example: {{createdAt}}' },
    Rounding: { value: '/', example: 'example: now/h' },
  },
];

type RelativeDatePanelProps = {
  /** if panel should show error  */
  hasRelativeError: boolean;
  /** function to set date */
  setRelativeDate: (date: string) => void;
  /** current date */
  currentDate: Moment | string;
  /** values to show in panel menu */
  relativeDateMenuValues?: RelativeDateValuesType;
};

export const RelativeDatePanel = ({
  hasRelativeError,
  setRelativeDate,
  currentDate,
  relativeDateMenuValues = RelativeDateValues,
}: RelativeDatePanelProps) => {
  return (
    <>
      <InputBar>
        <InputText
          data-test="relative-date-input"
          hasError={hasRelativeError}
          id="relative-date-input"
          placeholder={'Enter a date expression. (Example: now-7d-3h)'}
          value={currentDate as string}
          onChange={setRelativeDate}
          width={'100%'}
        />
      </InputBar>

      {hasRelativeError && (
        <ErrorText>
          <WarningFill color={colors.red100} />
          Please enter a valid date expression
        </ErrorText>
      )}

      <RelativeDateMenu>
        {relativeDateMenuValues.map((vals, idx) => (
          <RelativeDateColumn key={`relativeDate-column-${idx}`}>
            {Object.keys(vals).map((key) => (
              <RelativeDateFragment key={`relative-date-set-${key}`}>
                <RelativeDateValue>{vals[key].value}</RelativeDateValue>
                <div>{key}</div>
                {/* Render the example string if it exists */}
                {vals[key].example && <div>{vals[key].example}</div>}
              </RelativeDateFragment>
            ))}
          </RelativeDateColumn>
        ))}
      </RelativeDateMenu>
    </>
  );
};
